/**
 * Feature flags for the Line premium upgrade.
 *
 * Default-off for both features so existing sessions render exactly as they
 * do today. Flip via env (`VITE_LINE_CITATIONS=1`) or by editing this file
 * during a controlled rollout. Shared byte-for-byte between desktop and
 * mobile; there is no per-platform override.
 */

const flag = (name: string, fallback: boolean): boolean => {
  const raw = (import.meta.env?.[name] ?? '').toString().trim().toLowerCase()
  if (raw === '1' || raw === 'true' || raw === 'on') return true
  if (raw === '0' || raw === 'false' || raw === 'off') return false
  return fallback
}

export const lineFeatureFlags = {
  /** Inline citations plumbing + renderer. */
  citations: flag('VITE_LINE_CITATIONS', true),
  /** Ambient signal bus + heuristic evaluator + chip UI. */
  ambient: flag('VITE_LINE_AMBIENT', true),
  /** LLM refine pass over ambient opportunities (charges Cr on display). */
  ambientLLM: flag('VITE_LINE_AMBIENT_LLM', false),
  /**
   * Line/Line Pro/Line Max tier switcher above the AI Magic composer.
   * Default ON — Phase A–D already ship the additive layer with pre-rollout
   * users defaulting to `line`. Flip OFF via `VITE_AI_TIER_SWITCHER=0` to
   * hide the switcher UI immediately (kill switch, plan §5 Level 1 rollback).
   */
  aiTierSwitcher: flag('VITE_AI_TIER_SWITCHER', true),
} as const

export type LineFeatureFlagKey = keyof typeof lineFeatureFlags
